import { Quaternion, Euler, Vector3, Matrix4 } from "three";
const quat = new Quaternion();
const euler = new Euler();
const pos = new Vector3();
const scale = new Vector3();
const m4 = new Matrix4();
function coordsToMatrix({ longitude, latitude, altitude, fromLngLat }) {
  const center = fromLngLat([longitude, latitude], altitude);
  const scaleUnit = center.meterInMercatorCoordinateUnits();
  pos.set(center.x, center.y, center.z || 0);
  scale.set(scaleUnit, -scaleUnit, scaleUnit);
  quat.setFromEuler(euler.set(-Math.PI * 0.5, 0, 0));
  return m4.compose(pos, quat, scale).toArray();
}
export {
  coordsToMatrix
};
//# sourceMappingURL=main9.mjs.map
